
import { Component, Vue } from 'vue-property-decorator'
import StationForm from '@/components/trip/transportation/forms/generic/StationForm.vue'
import { TransportationType } from '@/utils/enums'
@Component({
  name: 'FerryForm',
  components: {
    StationForm,
  },
})
class FerryForm extends Vue {
  type: string = TransportationType.FERRY
}
export default FerryForm
